import { reactive, ref } from "vue";

import type { components as OpenAPI } from "@/autogen/openapi";
import { defineStore } from "@/lib/depot";

export const useStore = defineStore("errors", () => {
  const resource = ref<OpenAPI["schemas"]["ErrorMessage"][]>([]);
  const add = (error: OpenAPI["schemas"]["ErrorMessage"]) => {
    resource.value.push(error);
  };

  return reactive({
    resource,
    add,
  });
});
